import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import repository from '../services/ShopImportProfileRepository';
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import translate from '@astina/paloma-common-ui/src/services/Translator';
export function generateShopImportProfilePassword(profileId) {
    return new GenerateShopImportProfilePassword(profileId)
        .enqueue();
}
export default class GenerateShopImportProfilePassword extends AbstractCommand {
    profileId;
    disable;
    constructor(profileId, disable) {
        super();
        this.profileId = profileId;
        this.disable = disable;
    }
    execute() {
        return repository.generateInputPassword(this.profileId, this.disable)
            .then(passwordResponse => {
            alerts.success(translate('shop_import_profiles.generate_password_success'));
            return passwordResponse;
        });
    }
    needsConfirmation() {
        return true;
    }
    isDangerous() {
        return true;
    }
    name() {
        return 'generate_shop_import_profile_password';
    }
    icon() {
        return 'key';
    }
    requiresPermission() {
        return 'PORTAL_INTEGRATIONS_IMPORT';
    }
}
